import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { PhoneCall, MessageCircle } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="py-24 bg-[#F5F5F5] text-black border-t border-gray-200" data-id="element-27">
      <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-28">
        <FadeIn data-id="element-29">
          <h2 className="text-3xl md:text-5xl font-bold mb-12 max-w-3xl mx-auto" data-id="element-30">
            Не залишайтесь наодинці з проблемою
          </h2>

          <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12" data-id="element-31">
            <a href="tel:+380000000000" className="flex items-center justify-center gap-3 w-full md:w-auto px-8 py-4 bg-black text-white font-bold text-xl hover:bg-gray-800 transition-colors" data-id="element-32">
              <PhoneCall className="w-6 h-6" strokeWidth={2} data-id="element-33" />0 800 00 00 00
            </a>

            <div className="flex w-full md:w-auto gap-4" data-id="element-34">
              <a href="#" className="flex-1 md:flex-none flex items-center justify-center gap-2 px-6 py-4 bg-white border border-gray-200 hover:border-gray-400 transition-colors font-medium text-black" data-id="element-35">
                <MessageCircle className="w-5 h-5" data-id="element-36" />
                Telegram
              </a>
              <a href="#" className="flex-1 md:flex-none flex items-center justify-center gap-2 px-6 py-4 bg-white border border-gray-200 hover:border-gray-400 transition-colors font-medium text-black" data-id="element-37">
                <MessageCircle className="w-5 h-5" data-id="element-38" />
                Viber
              </a>
            </div>
          </div>

          <p className="text-gray-500 text-sm uppercase tracking-wider font-medium" data-id="element-39">
            Анонімно • Професійно • Цілодобово
          </p>
        </FadeIn>
      </div>
    </section>;
};